<script setup>
import { useCommerceContentModel } from '@/composables/useCommerceContentModel.js'
const props = defineProps({ modelValue: { type: Object, required: true } })
const emit = defineEmits(['update:modelValue'])
const form = useCommerceContentModel(props, emit)
const platforms = ['Facebook', 'Instagram', 'LINE', 'YouTube', 'TikTok', 'Threads', 'X']
function move(list, index, direction) {
  const next = index + direction
  if (next < 0 || next >= list.length) return
  list.splice(next, 0, list.splice(index, 1)[0])
}
</script>
<template>
  <fieldset class="footer-contact">
    <legend>客服與社群</legend>
    <p class="form-hint">此處填寫的內容會公開於商城；未填項目隱藏。</p>
    <label class="form-label">客服電話<input v-model="form.phone" type="tel" class="form-control" /></label>
    <label class="form-label">客服 Email<input v-model="form.email" type="email" class="form-control" /></label>
    <label class="form-label">服務時間<textarea v-model="form.serviceHours" class="form-control" rows="3" placeholder="週一至週五 09:00–18:00" /></label>
    <div v-for="(social, index) in form.socials" :key="index" class="social-row">
      <select v-model="social.platform" aria-label="社群平台" class="form-control"><option v-for="platform in platforms" :key="platform">{{ platform }}</option></select>
      <input v-model="social.href" class="form-control" aria-label="社群網址" placeholder="https://..." />
      <button type="button" class="btn btn-secondary btn-sm" :disabled="!index" @click="move(form.socials, index, -1)">上移</button>
      <button type="button" class="btn btn-secondary btn-sm" :disabled="index === form.socials.length - 1" @click="move(form.socials, index, 1)">下移</button>
      <button type="button" class="btn btn-secondary btn-sm" @click="form.socials.splice(index, 1)">移除</button>
    </div>
    <button type="button" class="btn btn-secondary" @click="form.socials.push({ platform: 'Facebook', href: '' })">新增社群</button>
    <p class="form-hint">電子報訂閱目前隱藏。</p>
  </fieldset>
</template>
<style scoped>
.footer-contact { margin-bottom: 24px; }.footer-contact>.form-label { display:block; margin: 12px 0; }.social-row { display:flex; flex-wrap:wrap; gap:8px; margin:12px 0; }.social-row select { width:150px; }.social-row input { flex:1; min-width:180px; }
.toggle-input { width: 18px; height: 18px; accent-color: #667eea; flex-shrink: 0; cursor: pointer; vertical-align: middle; }
</style>
